import classNames from "classnames";
import { CSSProperties, ReactNode } from "react";
import { Form, FormControlProps } from "react-bootstrap";

export interface SearchBoxProps extends FormControlProps {
  size?: "sm" | "lg";
  className?: string;
  placeholder?: string;
  style?: CSSProperties;
  formClassName?: string;
  inputClassName?: string;
  prepend?: ReactNode;
}

const SearchBox = ({
  size,
  style,
  className,
  formClassName,
  inputClassName,
  placeholder = "Search",
  prepend,
  ...rest
}: SearchBoxProps) => {
  return (
    <div className={classNames("search-box", 'position-relative', className)} style={style}>
      {prepend && (
        <span className="position-absolute top-50 start-0 translate-middle-y ms-3">
          {prepend}
        </span>
      )}
      <Form.Control
        type="search"
        placeholder={placeholder}
        className={classNames('search-input search', inputClassName, { 'ps-5': !!prepend })}
        size={size}
        {...rest}
      />
    </div>
  );
};

export default SearchBox;
